import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, Tab, Tabs } from '@mui/material';
import Header from '../components/common/Header';
import EarningsChart from '../components/dashboard/EarningsChart';
import ReferralsList from '../components/dashboard/ReferralsList';
import WeeklyBarChart from '../components/dashboard/WeeklyBarChart';
import { useNavigate } from 'react-router-dom';
import { queryInviteInfo } from '../api/modules/payment';
import { getInviteList } from '../api/modules/invite';
import { showMessage } from '../utils';
import { isInApp } from '../utils/environment';
import TopBar from '../components/TopBar';
import { removeToken } from '../utils/auth';
import { handleCopyLink, getShareUrl } from '../utils/share';

function InvitationsRecords() {
  const [activeTab, setActiveTab] = useState('referrals');
  const [timeRange, setTimeRange] = useState('7days');
  const [inviteInfo, setInviteInfo] = useState(null);
  const [inviteList, setInviteList] = useState([]);
  const navigate = useNavigate();
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const handleUserMenuOpen = (event) => setUserMenuAnchor(event.currentTarget);
  const handleUserMenuClose = () => setUserMenuAnchor(null);
  const shareUrl = getShareUrl();
  // 获取提现记录
  useEffect(() => {
    fetchInviteInfo();
    fetchInviteList();
  }, []);

  const fetchInviteList = () => {
    getInviteList((rst) => {
      const { code, rows, msg } = rst;
      if (rows?.length > 0) {
        setInviteList(rows);
      }
    });
  };

  const fetchInviteInfo = () => {
    queryInviteInfo({}, (rst) => {
      const { code, data, msg } = rst;
      if (code === 200) {
        setInviteInfo(data);
      } else {
        showMessage(msg, 'error');
      }
    });
  };

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
       {/* Logo和登录按钮区域 - PC端和移动端都显示 */}
      <TopBar
        isLogin={true}
        onShareClick={() => navigate('/campaigns/invitations/referral')}
        onCouponClick={() => navigate('/campaigns/invitations/tax-declaration')}
        onAvatarClick={handleUserMenuOpen}
        userMenuAnchor={userMenuAnchor}
        onUserMenuClose={handleUserMenuClose}
        handleCopyLink={() => handleCopyLink(shareUrl)}
        navigate={navigate}
        onLogout={() => {
          removeToken();
          showMessage("Logout successfully", "success");
          setTimeout(() => {
            navigate("/login");
          }, 1500);
          handleUserMenuClose();
        }}
      />
      <Container maxWidth="sm" sx={{ py: 2,mt: { xs: '56px', md: '64px' }, }}>
        {/* 黑色背景卡片 */}
        <Box sx={{
          bgcolor: '#000',
          borderRadius: '8px',
          p: 4,
          mb: 4,
          color: '#fff',
          position: 'relative',
          overflow: 'hidden'
        }}>

          {/* 金额显示 */}
          <Typography sx={{ 
            textAlign: 'center',
            fontSize: '36px',
            fontWeight: 'bold',
            mb: 2,
            mt: 3,
            color: '#fff'
          }}>
          <Typography sx={{ fontSize: '24px', fontWeight: 'normal' }}>Total Earning</Typography> ${inviteInfo?.rewardAmount || 0}
          </Typography>
          {/* 人数显示 */}
          <Typography sx={{ 
            textAlign: 'center',
            fontSize: '36px',
            fontWeight: 'bold',
            mb: 1,
            color: '#fff'
          }}>
          <Typography sx={{ fontSize: '24px', fontWeight: 'normal' }}>Total Client</Typography> {inviteInfo?.rewardCount || 0}
          </Typography>

          {/* 提现按钮 */}
          <Button
            variant="contained"
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              bgcolor: '#FFD700',
              color: '#000',
              fontWeight: 600,
              borderRadius: '12px',
              padding: '8px 16px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              '&:hover': {
                bgcolor: '#FFC700',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
              }
            }}
            onClick={() => navigate('/campaigns/invitations/withdrawal-records')}
          >
            Withdraw
          </Button>
        </Box>

        {/* 数据展示区域 */}
        <Box sx={{ mb: 3 }}>
          {/* 标题和切换按钮 */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}>
            <Typography variant="h6" sx={{ 
              fontWeight: 600,
              fontSize: '24px'
            }}>
              Referrals User
            </Typography>
            
            {/* 切换按钮 */}
            {/* <Button
              variant="contained"
              sx={{
                bgcolor: '#F5F5F5',
                color: '#000',
                textTransform: 'none',
                boxShadow: 'none',
                borderRadius: '12px',
                '&:hover': {
                  bgcolor: '#EEEEEE',
                  boxShadow: 'none'
                }
              }}
              onClick={() => setActiveTab(activeTab === 'earnings' ? 'referrals' : 'earnings')}
            >
              {activeTab === 'earnings' ? 'Earnings' : 'Referrals'} ▼
            </Button> */}
          </Box>

          {/* 图表区域 */}
          {activeTab === 'earnings' ? (
            <>
              <EarningsChart />
              <Box sx={{ mt: 3 }}>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    bgcolor: '#F5F5F5',
                    color: '#000',
                    textTransform: 'none',
                    boxShadow: 'none',
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    px: 3,
                    '&:hover': {
                      bgcolor: '#EEEEEE',
                      boxShadow: 'none'
                    }
                  }}
                  onClick={() => setTimeRange(timeRange === '7days' ? '30days' : '7days')}
                >
                  Last {timeRange === '7days' ? '7' : '30'} days ▼
                </Button>
                <WeeklyBarChart />
              </Box>
            </>
          ) : (
            <ReferralsList referralData={inviteList} />
          )}
        </Box>
      </Container>
    </Box>
  );
}

export default InvitationsRecords;
